// api/quote.js
const API_BASE_URL = process.env.VITE_API_BASE_URL || 'https://stage.getrevibe.app/api';

export const quoteApi = {
  // Fetch all quotes
  getQuotes: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/quote-banners`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return {
        success: true,
        quotes: data.quotes || [],
        total: data.total || 0,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        quotes: [],
      };
    }
  },

  // Get single quote by ID
  getQuoteById: async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/quote-banners/${id}`);
      if (!response.ok) throw new Error('Failed to fetch quote');
      const data = await response.json();
      return {
        success: true,
        quote: data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Get random quote (first one or random)
  getRandomQuote: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/quote-banners`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.quotes && data.quotes.length > 0) {
        // Get random quote from array
        const randomIndex = Math.floor(Math.random() * data.quotes.length);
        return {
          success: true,
          quote: data.quotes[randomIndex],
        };
      }
      
      return {
        success: false,
        error: 'No quotes available',
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Get first/featured quote
  getFeaturedQuote: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/quote-banners`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.quotes && data.quotes.length > 0) {
        return {
          success: true,
          quote: data.quotes[0],
        };
      }
      
      return {
        success: false,
        error: 'No quotes available',
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },
};